<template>
    <template
        v-for="(element, index) in inputItems"
        :key="'filt_'+index"
    >
        <filter-list-element
            v-if="!excludeDescriptors.includes(element.Descriptor)"
            v-model="inputItems[index]"
            :input-index="index"
            :owner-identity="ownerIdentity"
            :parent-id="undefined"
            :parent-name="''"
            :parent-idx="'filt_'+index"
        />
    </template>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-facing-decorator';
import FilterListElement from '@/components/common/filter-list/FilterListElement.vue';
import { AnalyticsElementIdentity } from '@/models/interfaces/entity-settings/charts/charts';
import _ from 'lodash';

@Component({
  name: 'AnalyticsFilterList',
  components: { FilterListElement }
})
export default class AnalyticsFilterList extends Vue {
    @Prop({ default: [] })
    inputItems!: any[]

    // Группы с этими дескрипторами пропускаются, но индексы остаются настоящими,
    // так как v-model должен писать в исходный массив стора, а не в отфильтрованную копию.
    @Prop({ default: () => [] })
    excludeDescriptors!: number[]

    // Элемент, которому принадлежат эти фильтры. Уходит в ключ записи валидации.
    @Prop({ default: undefined })
    ownerIdentity: AnalyticsElementIdentity | undefined

    created() {
        //
    }
}
</script>
